import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('bx_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const authStore = {
  get token() { return localStorage.getItem('bx_token'); },
  set token(v) {
    if (v) localStorage.setItem('bx_token', v);
    else localStorage.removeItem('bx_token');
  },
  get user() {
    const u = localStorage.getItem('bx_user');
    return u ? JSON.parse(u) : null;
  },
  set user(v) {
    if (v) localStorage.setItem('bx_user', JSON.stringify(v));
    else localStorage.removeItem('bx_user');
  },
  clear() {
    localStorage.removeItem('bx_token');
    localStorage.removeItem('bx_user');
  },
};
